import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import SvgIcon from '@material-ui/core/SvgIcon';
import MailIcon from '../icons/MailLetter.svg';
import MeIcon from '../icons/Me.svg';
import ChildMeIcon from '../icons/Child_Me.svg';
import Age from '../../../Helpers/Dates/Age';
import Family_Me from "../icons/Family_Me.svg";
import Spouse_Me from "../icons/Spouse_Me.svg";
import PlanInput from '../Helpers/Input/PlanInput';
import CircularProgress from '@material-ui/core/CircularProgress';
import BackNext from '../../Common/SubComponents/BackNext';
import HandIcon from '../icons/Hand.svg';
import CardIcon from '../icons/card.svg';
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import { IneligiblePerson } from "../Helpers/Constant"
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
export default function Ineligibility(props) {
    const { register, handleSubmit, setValue } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const useStyles = makeStyles(theme => ({
        primaryText: {
            color: theme.palette.primary.main
        },
        quoteText: {
            fontSize: '1rem',
            fontWeight: '400'
        }
    }));
    const classes = useStyles();
    const history = useHistory();
    const [planOptions, setPlanOptions] = useState(null);
    const [individualPlanPremium, setIndividualPlanPremium] = useState(null);
    const [oneParentFamilyPlanPremium, setOneParentFamilyPlanPremium] = useState(null);
    const [individualSpousePlanPremium, setIndividualSpousePlanPremium] = useState(null);
    const [familyPlanPremium, setFamilyPlanPremium] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        register({ name: 'plan' });
        setValue('plan', props.formState.plan !== "" ? props.formState.plan : "individualPremium");

    }, [register]);

    useEffect(() => {
        const form = setPlanAmount();
        props.onMultiFieldChange(form);
    }, [props.formState.plan]);
    
    useEffect(() => {
        const form = setPlanAmount();
        props.onMultiFieldChange(form);
    }, [individualPlanPremium]);

    const setPlanAmount = () => {
        let planAmount = 0;
        let premiumWithoutRider = 0;
        let extendedBenefitRiderPremium = 0;
        let hospitalStayAndSurgicalCareRiderPremium = 0;
        var form = { ...props.fullFormState };
        if (planOptions !== null) {
            planAmount = planOptions[props.formState.plan].premium;
            premiumWithoutRider = planOptions[props.formState.plan].premium;

            if (props.quoter.extendedBenefitRider) {
                planAmount = planAmount + planOptions[props.formState.plan].extendedBenefitRider;
                extendedBenefitRiderPremium = Number(planOptions[props.formState.plan].extendedBenefitRider).toFixed(2);
            }

            if (props.quoter.hospitalStayAndSurgicalCareRider) {
                planAmount = planAmount + planOptions[props.formState.plan].hospitalStayAndSurgicalCareRider;
                hospitalStayAndSurgicalCareRiderPremium = Number(planOptions[props.formState.plan].hospitalStayAndSurgicalCareRider).toFixed(2);
            }
            form.steps.ineligibility.planAmount = Number(planAmount).toFixed(2);
            form.steps.ineligibility.premiumWithoutRider = Number(premiumWithoutRider).toFixed(2);
            form.steps.ineligibility.extendedBenefitRiderPremium = extendedBenefitRiderPremium;
            form.steps.ineligibility.hospitalStayAndSurgicalCareRiderPremium = hospitalStayAndSurgicalCareRiderPremium;
        }
        return form;
    }
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    const age = Age(props.basicInfo.birthdate);
    const amount = props.quoter.coverageAmount;
    let childNames = "";
    let spouseName = ""
    const details = props.ineligible();
    let ineligiblePerson, ineligiblePersonName;
    if (details) {
        ineligiblePerson = details.ineligiblePerson;
        ineligiblePersonName = details.ineligiblePersonName;
        childNames = details.childIneligibleName;
        spouseName = details.spouseIneligibleName;
    }
    else {
        props.onBack()
    }
    useEffect(() => {
        if (ineligiblePerson !== IneligiblePerson.INSURED) {
            fetch(`${covrServicesUrl}/api/Aflac/GetAflacChoiceQuotes?state=${props.basicInfo.state}&age=${age}&hospitalAmount=${amount}&healthSavingsAccount=${props.basicInfo.hsaAccount}`, {
                method: 'GET',
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data) {
                        setPlanOptions(data);
                        setIsLoading(false);
                        setIndividualPlanPremium(Number(data.individualPremium.premium).toFixed(2));
                        setOneParentFamilyPlanPremium(Number(data.oneParentFamilyPremium.premium).toFixed(2))
                        setIndividualSpousePlanPremium(Number(data.namedSpousePremium.premium).toFixed(2));
                        setFamilyPlanPremium(Number(data.twoParentFamilyPremium.premium).toFixed(2));
                    }
                }).catch(() => {
                    setIsLoading(false);
                    setIsError(true);
                })
        }
        if (props.fullFormState.currentStep === 18) {
            const accountId = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.accountId;
            fetch(`/api/ConsumerApplication/CreateLeadRequest?accountId=${accountId}&productType=Supplemental Health`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
                },
                body: JSON.stringify(props.fullFormState)
            })
        }
        if (props.fullFormState.currentStep === 18)
            props.onStepFieldChange('ineligiblePerson', ineligiblePerson, 'ineligiblePersonName', ineligiblePersonName);
        else if (props.fullFormState.currentStep === 6)
            props.onStepFieldChange('ineligiblePersonOnBasicInfo', ineligiblePerson, 'ineligiblePersonNameOnBasicInfo', ineligiblePersonName);
    }, []);
    const individualPlan = {
        title: 'Just me',
        subtitle: 'Individual',
        amount: null,
        unit: 'mo',
        icon: MeIcon,
        value: props.formState.plan,
        field: 'individualPremium',
    }
    const oneParentFamiliPlan = {
        title: 'My children and me',
        subtitle: 'One-parent family',
        amount: null,
        unit: 'mo',
        icon: ChildMeIcon,
        value: props.formState.plan,
        field: 'oneParentFamilyPremium',
    }
    const individualSpousePlan = {
        title: "My spouse and me",
        subtitle: "Named Insured/Spouse only",
        amount: null,
        unit: "month",
        icon: Spouse_Me,
        value: props.formState.plan,
        field: "namedSpousePremium",
    };
    const familyPlan = {
        title: "My family and me",
        subtitle: "Two-parent family",
        amount: null,
        unit: "month",
        icon: Family_Me,
        value: props.formState.plan,
        field: "twoParentFamilyPremium",
    }

    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
    };
    const onSubmit = () => {
        props.onNext();
    };
    let ineligiblePersonArray = [];

    let childIneligibleName = "";
    let spouseChildIneligibleName = "";
    if (childNames && childNames.length > 0) {
        childNames.map((name, index) => {
            if (ineligiblePerson === IneligiblePerson.CHILD)
                ineligiblePersonArray.push(name);
            if (childNames.length - 1 === index && childNames.length >= 2) {
                childIneligibleName = `${childIneligibleName} and ${name.replace(props.fullFormState.steps.personalInfo.lastName, "").trim()}`;
            }
            else if (childNames.length - 2 === index) {
                childIneligibleName = `${childIneligibleName} ${name.replace(props.fullFormState.steps.personalInfo.lastName, "").trim()}`;
            }
            else if (childNames.length !== 1) {
                childIneligibleName = `${name.replace(props.fullFormState.steps.personalInfo.lastName, "").trim()}, ${childIneligibleName}`;
            }
            else {
                childIneligibleName = name.replace(props.fullFormState.steps.personalInfo.lastName, "").trim();
            }
        })
    }
    if (childNames && childNames.length > 0 && ineligiblePerson === IneligiblePerson.CHILD_SPOUSE) {
        ineligiblePersonArray.push(spouseName);
        childNames.map((name, index) => {
            ineligiblePersonArray.push(name);
            if (childNames.length - 1 === index) {
                spouseChildIneligibleName = `${spouseChildIneligibleName} ${name.replace(props.fullFormState.steps.personalInfo.lastName, "").trim()}`;
            }
            else if (childNames.length !== 1) {
                spouseChildIneligibleName = `${name.replace(props.fullFormState.steps.personalInfo.lastName, "").trim()}, ${spouseChildIneligibleName}`;
            }
            else {
                spouseChildIneligibleName = name.replace(props.fullFormState.steps.personalInfo.lastName, "").trim();
            }
        });

    }
    spouseChildIneligibleName = `${spouseChildIneligibleName} and ${props.fullFormState.steps.spouseInfo.firstName}`
    if (ineligiblePerson === IneligiblePerson.SPOUSE || ineligiblePerson === IneligiblePerson.INSURED)
        ineligiblePersonArray.push(ineligiblePersonName)
    return (
        <Container fluid className='Ineligibility border-class'>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="justify-content-center mt-4">
                    <Col className='col-div'>
                        <div className="text-center mb-2 pt-4"><SvgIcon component={MailIcon} className="small-icons" color="primary" fontSize="large" /></div>
                        <h4 className="text-center mb-3">Thank you for your interest.</h4>
                        {(ineligiblePerson === IneligiblePerson.SPOUSE || ineligiblePerson === IneligiblePerson.CHILD || ineligiblePerson == IneligiblePerson.CHILD_SPOUSE) ? (
                            <React.Fragment>
                                <h6 className="applicant-info">The following  {ineligiblePersonArray.length >= 2 ? "applicants are" : "applicant is"} not eligible to apply for this insurance.</h6>
                                {ineligiblePersonArray.map((data, index) => {
                                    return (<h6 className="applicant-name mb-3" key={index}>{data}</h6>)
                                })}
                            </React.Fragment>
                        ) : (

                                <React.Fragment>
                                    <h6 >The following applicant is not eligible to apply for this insurance.</h6>
                                    <h6 className="applicant-name mb-3">{ineligiblePersonName}</h6>
                                    <h6 className=" mb-3">Ineligibility may be based on product suitability or other information provided in this application. </h6>
                                    <h5 className="text-center">Your Coverage Options</h5>
                                </React.Fragment>
                            )}
                        {ineligiblePerson === IneligiblePerson.SPOUSE && (
                            <React.Fragment>
                                <h6 className="coverage-info"> {props.fullFormState.currentStep === 6 ? "Your spouse" : props.fullFormState.steps.spouseInfo.firstName} is not eligible, but you can still get coverage.</h6>
                                <h6 className="coverage-option">Your Coverage Options</h6>
                            </React.Fragment>
                        )}
                        {ineligiblePerson === IneligiblePerson.CHILD && (
                            <React.Fragment>
                                <h6 className="coverage-info">Unfortunately, {childIneligibleName}  {ineligiblePersonArray.length >= 2 ? "are" : "is"} not eligible for coverage. However, if you have other children under the age of 26, you can continue with your selected plan (excluding {`${childIneligibleName}`}), or you may select another coverage option.</h6>
                                <h6 className="coverage-option">Your Coverage Options</h6>
                            </React.Fragment>
                        )}
                        {ineligiblePerson === IneligiblePerson.CHILD_SPOUSE && (
                            <React.Fragment>
                                <h6 className="coverage-info">
                                    Unfortunately, {spouseChildIneligibleName} are not eligible for coverage. However, if you have other children under the age of 26, you can continue with My Children and me (excluding {childIneligibleName}), or you may select another coverage option.</h6>
                                <h6 className="coverage-option">Your Coverage Options</h6>
                            </React.Fragment>
                        )}
                        {ineligiblePerson === IneligiblePerson.INSURED ? (
                            <Row className="justify-content-center mb-4">
                                <Col sm={6} className="col-6 p-0">
                                    <div className="text-center OfferCard">
                                        <Row className="justify-content-center">
                                            <SvgIcon component={CardIcon} color="primary" fontSize="large" className="small-icons" />
                                        </Row>
                                        <span> Term Life <br /> Insurance</span><br />
                                        <br />
                                        <span onClick={() => { history.push(`/landing/term`); }} className={`link ${classes.primaryText}`}><p className={classes.quoteText}>QUICK QUOTE</p>DETAILS</span>
                                    </div>
                                </Col>

                                <Col sm={6} className="col-6 p-0">
                                    <div className="text-center OfferCard">
                                        <Row className="justify-content-center">
                                            <SvgIcon component={HandIcon} color="primary" fontSize="large" className="small-icons" />
                                        </Row>
                                        <span>Perm Life <br /> Insurance</span><br /><br />
                                        <span onClick={() => { history.push(`/landing/permanent`); }} className={`link ${classes.primaryText}`}><p className={classes.quoteText}>QUICK QUOTE</p> DETAILS</span>
                                    </div>
                                </Col>
                            </Row>

                        ) : (
                                ineligiblePerson !== IneligiblePerson.INSURED && isLoading ? <Row className="justify-content-center mt-3"  >
                                    <CircularProgress />
                                </Row> : isError ? <Row className="justify-content-center mt-3"  >
                                    <Col lg={12}>
                                        There is some error while fetching rates. Please try again.</Col>
                                </Row> : <Row className="justify-content-center mt-3 mb-4" role="group" >
                                            {
                                                ineligiblePerson === IneligiblePerson.CHILD_SPOUSE &&
                                                <React.Fragment>
                                                    <Col sm={6} key={1} className='btn-wrapper mt-2'>
                                                        <PlanInput
                                                            icon={individualPlan.icon}
                                                            title={individualPlan.title}
                                                            subtitle={individualPlan.subtitle}
                                                            amount={individualPlanPremium}
                                                            field={individualPlan.field}
                                                            value={props.formState.plan === individualPlan.field}
                                                            unit={individualPlan.unit}
                                                            onClick={() => handleValueChange('plan', individualPlan.field)}
                                                            mobileWide={true}
                                                        />
                                                    </Col>
                                                    <Col sm={6} key={2} className='btn-wrapper mt-2'>
                                                        <PlanInput
                                                            icon={oneParentFamiliPlan.icon}
                                                            title={oneParentFamiliPlan.title}
                                                            subtitle={oneParentFamiliPlan.subtitle}
                                                            amount={oneParentFamilyPlanPremium}
                                                            field={oneParentFamiliPlan.field}
                                                            value={props.formState.plan === oneParentFamiliPlan.field}
                                                            unit={oneParentFamiliPlan.unit}
                                                            onClick={() => handleValueChange('plan', oneParentFamiliPlan.field)}
                                                            mobileWide={true}
                                                        />
                                                    </Col>
                                                </React.Fragment>
                                            }
                                            {ineligiblePerson === IneligiblePerson.SPOUSE &&
                                                <React.Fragment>
                                                    <Col sm={6} key={1} className='btn-wrapper mt-2'>
                                                        <PlanInput
                                                            icon={individualPlan.icon}
                                                            title={individualPlan.title}
                                                            subtitle={individualPlan.subtitle}
                                                            amount={individualPlanPremium}
                                                            field={individualPlan.field}
                                                            value={props.formState.plan === individualPlan.field}
                                                            unit={individualPlan.unit}
                                                            onClick={() => handleValueChange('plan', individualPlan.field)}
                                                            mobileWide={true}
                                                        />
                                                    </Col>
                                                    {
                                                        props.selectedPlan === "twoParentFamilyPremium" &&
                                                        <Col sm={6} key={2} className='btn-wrapper mt-2'>
                                                            <PlanInput
                                                                icon={oneParentFamiliPlan.icon}
                                                                title={oneParentFamiliPlan.title}
                                                                subtitle={oneParentFamiliPlan.subtitle}
                                                                amount={oneParentFamilyPlanPremium}
                                                                field={oneParentFamiliPlan.field}
                                                                value={props.formState.plan === oneParentFamiliPlan.field}
                                                                unit={oneParentFamiliPlan.unit}
                                                                onClick={() => handleValueChange('plan', oneParentFamiliPlan.field)}
                                                                mobileWide={true}
                                                            />
                                                        </Col>
                                                    }

                                                </React.Fragment>}
                                            {ineligiblePerson === IneligiblePerson.CHILD && (
                                                <React.Fragment>
                                                    <Col sm={6} key={1} className='btn-wrapper mt-2'>
                                                        <PlanInput
                                                            icon={individualPlan.icon}
                                                            title={individualPlan.title}
                                                            subtitle={individualPlan.subtitle}
                                                            amount={individualPlanPremium}
                                                            field={individualPlan.field}
                                                            value={props.formState.plan === individualPlan.field}
                                                            unit={individualPlan.unit}
                                                            onClick={() => handleValueChange('plan', individualPlan.field)}
                                                            mobileWide={true}
                                                        />
                                                    </Col>
                                                    {
                                                        props.selectedPlan === "oneParentFamilyPremium" ?
                                                            <Col sm={6} key={2} className='btn-wrapper mt-2'>
                                                                <PlanInput
                                                                    icon={oneParentFamiliPlan.icon}
                                                                    title={oneParentFamiliPlan.title}
                                                                    subtitle={oneParentFamiliPlan.subtitle}
                                                                    amount={oneParentFamilyPlanPremium}
                                                                    field={oneParentFamiliPlan.field}
                                                                    value={props.formState.plan === oneParentFamiliPlan.field}
                                                                    unit={oneParentFamiliPlan.unit}
                                                                    onClick={() => handleValueChange('plan', oneParentFamiliPlan.field)}
                                                                    mobileWide={true}
                                                                />
                                                            </Col>
                                                            :
                                                            <React.Fragment>
                                                                 <Col sm={6} key={2} className='btn-wrapper mt-2'>
                                                                 <PlanInput
                                                                    icon={individualSpousePlan.icon}
                                                                    title={individualSpousePlan.title}
                                                                    subtitle={individualSpousePlan.subtitle}
                                                                    amount={individualSpousePlanPremium}
                                                                    field={individualSpousePlan.field}
                                                                    value={props.formState.plan === individualSpousePlan.field}
                                                                    unit={individualSpousePlan.unit}
                                                                    onClick={() => handleValueChange('plan', individualSpousePlan.field)}
                                                                    mobileWide={true}
                                                                />  
                                                            </Col>
                                                                <Col sm={6} key={2} className='btn-wrapper mt-2'>
                                                                <PlanInput
                                                                    icon={oneParentFamiliPlan.icon}
                                                                    title={oneParentFamiliPlan.title}
                                                                    subtitle={oneParentFamiliPlan.subtitle}
                                                                    amount={oneParentFamilyPlanPremium}
                                                                    field={oneParentFamiliPlan.field}
                                                                    value={props.formState.plan === oneParentFamiliPlan.field}
                                                                    unit={oneParentFamiliPlan.unit}
                                                                    onClick={() => handleValueChange('plan', oneParentFamiliPlan.field)}
                                                                    mobileWide={true}
                                                                />
                                                            </Col>
                                                            <Col sm={6} key={4} className='btn-wrapper mt-2'>
                                                                <PlanInput
                                                                    icon={familyPlan.icon}
                                                                    title={familyPlan.title}
                                                                    subtitle={familyPlan.subtitle}
                                                                    amount={familyPlanPremium}
                                                                    field={familyPlan.field}
                                                                    value={props.formState.plan === familyPlan.field}
                                                                    unit={familyPlan.unit}
                                                                    onClick={() => handleValueChange('plan', familyPlan.field)}
                                                                    mobileWide={true}
                                                                />
                                                            </Col>
                                                            </React.Fragment>
                                                    }
                                                </React.Fragment>
                                            )}
                                        </Row>
                            )}
                    </Col>
                </Row>
                {ineligiblePerson !== IneligiblePerson.INSURED && (
                    <div className='backnext-wrapper'>
                        <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
                    </div>
                )}

            </Form>
        </Container>

    );
}

Ineligibility.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

Ineligibility.DefaultFormState = (prefill = false) => {
    return {
        plan: 'individualPremium',
        ineligiblePerson: '',
        ineligiblePersonName: '',
        ineligiblePersonNameOnBasicInfo: '',
        ineligiblePersonOnBasicInfo: '',
        planAmount: null,
        premiumWithoutRider: null,
        extendedBenefitRiderPremium: null,
        hospitalStayAndSurgicalCareRiderPremium: null
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/Ineligibility.js